import { QuillEditor } from "../../../../components/QuillEditor";
import { formDataType } from "../../Create/AddSite";

interface ScopeOfWorkProps {
  formData: formDataType;
  setFormData: React.Dispatch<React.SetStateAction<formDataType>>;
}

export function ScopeOfWork({ formData, setFormData }: ScopeOfWorkProps) {
  return (
    <div>
      <QuillEditor
        label="Scope Of Work"
        content={formData.scope_of_work}
        setContent={val => {
          setFormData({
            ...formData,
            scope_of_work: val,
          });
        }}
        required={true}
        hidePlaceholder={true}
      />
    </div>
  );
}
